import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { marked } from 'marked';
import { __experimentalUseSlotFills } from '@wordpress/components';

window.ekr_ai_image_content = '';
window.ekr_ai_image_name = '';
const attachments = new Map();
let aiSessionId = uuidv4(),
	aborter = new AbortController(),
	timerInterval = null,
	realtimeSeconds = 0,
	pc = null,  // Connessione Peer
	dc = null,  // Canale Dati
	ms = null;  // MediaStream per il microfono

// Inizializza l'array che salva le domande e risposte della chat realtime
let chatQuestionandAnswer = [];

// Flag per tracciare se dobbiamo riaprire la connessione
let shouldReopenConnection = false;

const readDataSSE = async (url, params) => {
	try {
		const response = await fetch(url, params);
		const reader = response.body
			.pipeThrough(new TextDecoderStream())
			.getReader();
		let partialResponse = '';
		let finalAnswerText = '';

		while (true) {
			const { value, done } = await reader.read();
			if (done) {
				//Non più necessario dato che la modalità non progressiva usa endopoint differente
				/*// Se NON siamo in modalità progressiva, processiamo tutta la risposta ora
				if (window.ekr_chat_ai_data.progressiveResponse !== '1') {
					try {
						const finalObj = partialResponse
							.split('\n\n')
							.filter(el => el !== '')
							.map(
								el => el.split('\n')
									.filter(item => item.startsWith('data:'))
									.map(item => JSON.parse(item.substring(item.indexOf(':') + 1)))
							)
							.flat();

						finalObj.forEach(data => {
							finalAnswerText = data.answer;
							updateAnswerItemContent(marked.parse(data.answer));
						});
					} catch (e) {
						console.error('Errore nel parsing finale:', e);
					}
				}*/

				updateAnswerItem();
				enableAiForm();
				break;
			}

			partialResponse += value;

			// Modalità progressiva (mostra i chunk man mano)
			//if (window.ekr_chat_ai_data.progressiveResponse === '1') {
				try {
					const obj = partialResponse
						.split('\n\n')
						.filter(el => el !== '')
						.map(
							el => el.split('\n')
								.filter(item => item.startsWith('data:'))
								.map(item => JSON.parse(item.substring(item.indexOf(':') + 1)))
						)
						.flat();

					if (obj.length > 0 && obj[0].hasOwnProperty('msgError')) {
						if (obj[0].msgError.trim().length > 0) {
							alert(obj[0].msgError);
							updateAnswerItem();
						}
					}

					obj.forEach(data => {
						finalAnswerText = data.answer;
						updateAnswerItemContent(marked.parse(data.answer));
					});

					$('#chatAudioButton').prop('disabled', false);
					partialResponse = '';
				} catch (e) {
					$('#chatAudioButton').prop('disabled', false);
					if (!(e instanceof SyntaxError)) {
						console.error(e);
					}
				}
			//}
		}
	} catch (e) {
		$('#chatAudioButton').prop('disabled', false);
		if (typeof transcriptions !== 'undefined' && transcriptions.length > 0) {
			$('#chatSendAudioButton').prop('disabled', false);
		}
		console.error(e.name === 'AbortError' ? 'Aborted by user' : e);
		updateAnswerItem();
	}
};

const readData = async (url, params) => {
	try {
		const response = await fetch(url, params);
		const data = await response.json();
		updateAnswerItemContent(marked.parse(data.answer));
		enableAiForm();
	} catch (e) {
		$('#chatAudioButton').prop('disabled', false);
		if (typeof transcriptions !== 'undefined' && transcriptions.length > 0) {
			$('#chatSendAudioButton').prop('disabled', false);
		}
		console.error(e.name === 'AbortError' ? 'Aborted by user' : e);
		updateAnswerItem();
	}
};

// Simula click sul pulsante End Call
const closeRealtimeCall = () => {
	const endCallButton = document.querySelector('.end-call-button');
	if (endCallButton) {
		endCallButton.click();
		//endCallButton.trigger('click'); // da implementare perchè il click diventerà deprecato
		return true;
	}
	return false;
};

// Simula click sul pulsante Audio per riaprire la connessione
const openRealtimeCall = async () => {
	const audioButton = document.querySelector('#chatAudioButton');
	if (audioButton && !audioButton.disabled) {
		//audioButton.trigger('click');  // da implementare perchè il click diventerà deprecato
		audioButton.click();

		// Attendi che la connessione sia stabilita E che la sessione sia configurata
		return new Promise((resolve) => {
			let connectionEstablished = false;
			let sessionConfigured = false;

			// Listener temporaneo per session.updated
			const sessionUpdateHandler = (e) => {
				const data = JSON.parse(e.data);
				if (data.type === "session.updated") {
					sessionConfigured = true;
					dc.removeEventListener("message", sessionUpdateHandler);
				}
			};

			const checkConnection = setInterval(() => {
				// Verifica connessione DataChannel
				if (dc && dc.readyState === "open" && !connectionEstablished) {
					connectionEstablished = true;
					// Aggiungi listener per session.updated
					dc.addEventListener("message", sessionUpdateHandler);
				}

				// Se tutto è pronto, risolvi
				if (connectionEstablished && sessionConfigured) {
					clearInterval(checkConnection);
					resolve(true);
				}
			}, 100);

			// Timeout dopo 15 secondi
			setTimeout(() => {
				clearInterval(checkConnection);
				dc.removeEventListener("message", sessionUpdateHandler);
				if (connectionEstablished && sessionConfigured) {
					resolve(true);
				} else {
					console.warn('Timeout durante la riconnessione (DC:', connectionEstablished, 'Session:', sessionConfigured, ')');
					// Risolvi comunque true se almeno il DC è aperto
					resolve(connectionEstablished);
				}
			}, 15000);
		});
	}
	return false;
};

// Mostra messaggio di processing nella chat
const showProcessingMessage = (message = 'Sto elaborando la tua richiesta, attendi...') => {
	const container_text = $('#container_text_AI');
	const scrollPosition = $(window).scrollTop();
	const processingContainer = createAnswerItem(false, marked.parse(`⏳ **${message}**`));
	appendItem(container_text, processingContainer);
	$(window).scrollTop(scrollPosition);
};

// Controlla se l'answer contiene il placeholder trigger + SavePallet (se attivo)
const checkPlaceholderAnswer = async function (answer) {
	const placeholder = window.ekr_chat_ai_data.realtimetrigger;
	const fullChatChronology = window.ekr_chat_ai_data.fullChatChronology === 'true';
	const regex = new RegExp(`\\b${placeholder}\\b`, "i");
	const chronologyTrigger = window.ekr_chat_ai_data.ChronologyTrigger;

	if (placeholder !== '' && regex.test(answer)) {
		// CHIUDI LA CHIAMATA VOCALE
		closeRealtimeCall();

		// Imposta flag per riaprire la connessione dopo
		shouldReopenConnection = true;

		// Mostra messaggio di processing
		showProcessingMessage('Elaborazione in corso...');

		let result = '';

		// Controlliamo se mandare tutta la chat oppure solo l'ultimo messaggio con il trigger
		if (fullChatChronology) {
			result = chatQuestionandAnswer.join('\n');
		} else {
			for (let i = chatQuestionandAnswer.length - 1; i >= 0; i--) {
				if (chatQuestionandAnswer[i].toLowerCase().includes(chronologyTrigger.toLowerCase())) {
					const lastMsg = chatQuestionandAnswer[i].slice(8);
					result = lastMsg;
					break;
				}
			}
		}

		console.log('Messaggio da elaborare:', result);

		if (result === '') {
			const errorMsg = 'Nessun messaggio trovato con il trigger specificato.';

			// Riapri connessione
			await openRealtimeCall();

			// Attendi stabilizzazione e fai parlare l'AI
			setTimeout(() => {
				speakViaRealtime(errorMsg, dc);
			}, 1000);
		} else {
			const fetchParams = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					question: result,
					logEnabled: window.ekr_chat_ai_data.chat_log_value === '1',
					aiSessionId: aiSessionId,
					//se serve anche nel caso di lettura placeholder, decommentare
					//sendFileToAiFromlabelBox: window.ekr_chat_ai_data.sendFileToAiFromlabelBox,
					queryParams: window.ekr_chat_ai_data.ai_query_params
				}),
				signal: aborter.signal
			};
			chatQuestionandAnswer = [];

			// Se la SavePallet è ATTIVA
			if (window.ekr_chat_ai_data.savePallet === '1' && window.ekr_chat_ai_data.xsltTags.length > 0) {
				const response = await fetch(window.ekr_chat_ai_data.sse_ai_url, fetchParams);
				const reader = response.body.getReader();
				let decoder = new TextDecoder('utf-8');
				let partialResponse = '';
				let finalAnswerText = '';

				while (true) {
					const { value, done } = await reader.read();
					if (done) {
						try {
							const finalObj = partialResponse
								.split('\n\n')
								.filter(el => el !== '')
								.map(el =>
									el.split('\n')
										.filter(item => item.startsWith('data:'))
										.map(item => JSON.parse(item.substring(item.indexOf(':') + 1)))
								)
								.flat();

							finalObj.forEach(data => {
								if (data.answer) {
									finalAnswerText = data.answer;
								}
							});

							console.log("XML ricevuto:", finalAnswerText);
							let parser = new DOMParser();
							let doc = parser.parseFromString(finalAnswerText, "application/xml");
							let errorNode = doc.querySelector('parsererror');

							if (errorNode) {
								console.error("Errore nel parsing XML:", errorNode.textContent);

								// Riapri connessione
								await openRealtimeCall();

								// Attendi e fai parlare l'AI
								setTimeout(() => {
									speakViaRealtime("Errore nel parsing XML", dc);
								}, 1000);
							} else {
								console.log("XML è valido");
								const xml = finalAnswerText;
								const tag = window.ekr_chat_ai_data.xsltTags;

								fetch(window.ekr_chat_ai_data.ajax_url, {
									method: 'POST',
									body: new URLSearchParams({
										action: 'transform_xml',
										xml: xml,
										tag: tag
									})
								})
									.then(async res => {
										// Riapri connessione PRIMA di far parlare l'AI
										await openRealtimeCall();

										// Attendi stabilizzazione e fai parlare l'AI
										setTimeout(() => {
											if (res.ok) {
												speakViaRealtime(window.ekr_chat_ai_data.sucsessMessage, dc);
											} else {
												speakViaRealtime(window.ekr_chat_ai_data.errorMessage, dc);
											}
										}, 1000);
									})
									.catch(async err => {
										console.error('Errore trasformazione XML:', err);

										// Riapri connessione
										await openRealtimeCall();

										// Attendi e fai parlare l'AI
										setTimeout(() => {
											speakViaRealtime('Errore trasformazione XML', dc);
										}, 1000);
									});
							}
						} catch (e) {
							console.error("Errore nel parsing:", e);

							// Riapri connessione
							const reconnected = await openRealtimeCall();

							if (reconnected) {
								// Attendi 2 secondi per stabilizzazione
								setTimeout(() => {
									speakViaRealtime("Errore nel parsing", dc);
								}, 2000);
							} else {
								// Fallback: mostra solo testo
								const container_text = $('#container_text_AI');
								const scrollPosition = $(window).scrollTop();
								const answerContainer = createAnswerItem(false, marked.parse(window.ekr_chat_ai_data.errorMessage));
								appendItem(container_text, answerContainer);
								$(window).scrollTop(scrollPosition);
							}
						}

						break;
					}

					partialResponse += decoder.decode(value, { stream: true });
				}
			} else {
				// Caso senza savePallet: usa readDataSSE
				readData(window.ekr_chat_ai_data.ai_url, fetchParams);
			}
		}
	}
};

// ==================== SPEAK VIA REALTIME ====================

const speakViaRealtime = (text, dataChannel) => {
	console.log('Stato connessione:', {
		text: text,
		dcState: dataChannel ? dataChannel.readyState : 'null',
		pcState: pc ? pc.connectionState : 'null',
		msActive: ms ? ms.active : 'null'
	});

	// Verifica che il dataChannel sia aperto
	if (!dataChannel || dataChannel.readyState !== "open") {
		console.error("Data channel non disponibile!");

		// Mostra il messaggio solo come testo nella chat
		const container_text = $('#container_text_AI');
		const scrollPosition = $(window).scrollTop();
		const answerContainer = createAnswerItem(false, marked.parse(text));
		appendItem(container_text, answerContainer);
		$(window).scrollTop(scrollPosition);

		return false;
	}

	// Questo forza l'AI a rispondere con audio
	const userMessageEvent = {
		type: "conversation.item.create",
		item: {
			type: "message",
			role: "user",
			content: [
				{
					type: "input_text",
					text: `Sei un assistente e devi dare la risposta dopo un caricamento dei dati, rispondi SOLO con questo testo esatto, senza aggiungere nulla: "${text}"`
				}
			]
		}
	};

	dataChannel.send(JSON.stringify(userMessageEvent));

	// Trigger per far generare la risposta audio
	const responseEvent = {
		type: "response.create",
		response: {
			modalities: ["text", "audio"],
			instructions: `Devi rispondere SOLO con questo testo esatto: "${text}". Non aggiungere nulla, non modificare nulla, ripeti solo questo testo.`
		}
	};

	console.log('Trigger response.create con istruzioni');
	dataChannel.send(JSON.stringify(responseEvent));

	return true;
};

const sendRequest = function (question = '') {
	$('#chatAudioButton').prop('disabled', true);
	$('#chatSendAudioButton').prop('disabled', true);
	const container_text = $('#container_text_AI'),
		input = $('#input_chat_AI');
	if (!question) {
		question = input.val();
	}
	if (question) {
		const request = createRequestItem(question);
		enableAiForm(false);
		const scrollPosition = $(window).scrollTop();
		appendItem(container_text, request);
		window.ekr_chat_ai_data.realtimetrigger !== '' && (chatQuestionandAnswer.push('question: ' + question), console.log('question: ' + question));

		const answerContainer = createAnswerItem(true);
		appendItem(container_text, answerContainer);
		$(window).scrollTop(scrollPosition);

		let fetchParams = null;

		if ((window.ekr_chat_ai_data.enableKag === true || window.ekr_chat_ai_data.enableKag === 'true')&& window.ekr_chat_ai_data.kagPalletCode !== '')
		{
			fetchParams = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				question: request.text(),
				imageRequest: Array.from(attachments.values()),
				logEnabled: window.ekr_chat_ai_data.chat_log_value === '1',
				aiSessionId: aiSessionId,
				sendFileToAiFromlabelBox: window.ekr_chat_ai_data.sendFileToAiFromlabelBox,
				kag: window.ekr_chat_ai_data.enableKag === true || window.ekr_chat_ai_data.enableKag === 'true',
				kagPalletCode: window.ekr_chat_ai_data.kagPalletCode,
				queryParams: window.ekr_chat_ai_data.ai_query_params
			}),
			signal: aborter.signal
			};
		} else {
			fetchParams = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				question: request.text(),
				imageRequest: Array.from(attachments.values()),
				logEnabled: window.ekr_chat_ai_data.chat_log_value === '1',
				aiSessionId: aiSessionId,
				sendFileToAiFromlabelBox: window.ekr_chat_ai_data.sendFileToAiFromlabelBox,
				queryParams: window.ekr_chat_ai_data.ai_query_params
			}),
			signal: aborter.signal
			};
		}

		
		if (window.ekr_chat_ai_data.progressiveResponse === '1') {
			readDataSSE(window.ekr_chat_ai_data.sse_ai_url, fetchParams);
		} else {
			readData(window.ekr_chat_ai_data.ai_url, fetchParams);
		}

		const items = document.querySelectorAll('.attachment-item');
		items.forEach(item => item.remove());
		input.val('');
		input.css('height', 'auto');
		input.css('overflow-y', 'hidden');
		attachments.clear();
	}
};

const importImage = function () {
	let input = document.createElement('input');
	input.type = 'file';
	input.onchange = e => {
		let file = e.target.files[0];
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = readerEvent => {
			let content = readerEvent.target.result;
			window.ekr_ai_image = content;
			const container = document.getElementById('attachments-container');
			container.addEventListener('click', (event) => {
				if (event.target.classList.contains('remove-attachment-btn')) {
					const item = event.target.parentElement;
					attachments.delete(item.dataset.itemId)
					container.removeChild(item);
				}
			});
			const newItem = document.createElement('div');
			let itemId = crypto.randomUUID();
			newItem.className = 'attachment-item';
			newItem.dataset.itemId = itemId;
			newItem.innerHTML = `
            <span>🖼️${file.name}</span>
            <button class="remove-attachment-btn" id="remove-attachment-btn">X</button>
        	`;
			container.appendChild(newItem);

			attachments.set(itemId,{
				name:file.name.split('.')[0],
				extension:file.name.split('.')[1],
				mimetype:content.split(';')[0].split(':')[1],
				content:content.split(';')[1].split(',')[1]
			});
		}
	}
	//input.trigger('click'); // da implementare perchè il click diventerà deprecato
	input.click();
};

const appendItem = function (container, item, delay = false) {
    const appendFn = (container = this) => {
        if (
			(document.getElementsByClassName('attachment-item').length > 0) &&
			$(item).hasClass('request_item_container')
		) {
			const img = document.createElement('img');
			img.src = window.ekr_ai_image;
			img.style.maxWidth = '100px';
			img.style.display = 'block';
			img.style.marginBottom = '5px';

			const chatItem = $(item)[0].querySelector('.chat_item.request_item');
			if (chatItem) {
				chatItem.prepend(img);
			}
		}

        $(container).append(item);
        item[0].scrollIntoView(false);
        $(this).dequeue();
    };

    if (delay === false) {
        appendFn(container);
    } else {
        container.delay(delay).queue(appendFn);
    }
};

const createRequestItem = function (text) {
	return $('<div/>')
		.addClass('request_item_container')
		.append($('<div/>').addClass('user_icon icon1'))
		.append($('<div/>').addClass('chat_item request_item').text(text));
};

const createAnswerItem = function (isWaiting = true, htmlText = null) {
	const answer = $('<div/>').addClass('chat_item answer_item');

	if (isWaiting) {
		const cubes = 9,
			spinner = $('<div/>').addClass('sk-cube-grid');

		for (let i = 1; i <= cubes; i++) {
			const cube = $('<div/>')
				.addClass('sk-cube')
				.addClass(`sk-cube${i}`);
			spinner.append(cube);
		}

		if (window.ekr_chat_ai_data.progressiveResponse === '') {
			const divEsterno = $('<div/>').addClass('loading-div'),
				spanText = $('<span/>').addClass('loading-message').text(window.ekr_chat_ai_data.loadingMessage);
			divEsterno.append(spinner);
			divEsterno.append(spanText);
			answer.append(divEsterno);
		} else {
			answer.append(spinner);
		}
	} else {
		updateAnswerItem(htmlText, answer);
	}

	return $('<div/>')
		.addClass('answer_item_container')
		.append($('<div/>').addClass('ai_icon ' + window.ekr_chat_ai_data.ai_icon))
		.append(answer);
};

const scrollToBottom = function (item) {
	item.scrollTop(item[0].scrollHeight);
};

const updateAnswerItem = function (htmlText = null, item = null) {
	const itemToUpdate = item || $('.chat_item.answer_item').last();
	itemToUpdate.children('.loader').remove();

	if (htmlText !== null) {
		itemToUpdate.html(htmlText);
	}
	scrollToBottom($('#container_text_AI'));
};

const updateAnswerItemContent = function (htmlText, item = null) {
	const itemToUpdate = item || $('.chat_item.answer_item').last();
	if (htmlText !== null) {
		itemToUpdate.html(htmlText);
	}
	scrollToBottom($('#container_text_AI'));
};

const enableAiForm = function (enabled = true) {
	$('#btn_abort').toggleClass('ekr_hidden', enabled);
	$('#button_input_AI').toggleClass('ekr_hidden', !enabled);
	const input = $('#input_chat_AI');
	input.prop('disabled', !enabled);
	if (enabled) {
		//input.trigger('focus'); // da implementare perchè il focus diventerà deprecato
		input.focus();
	}
};

const enter = function (input, button_chat) {
	if (event.keyCode === 13) {
		event.preventDefault();
		//button_chat.trigger('click'); // da implementare perchè il click diventerà deprecato
		button_chat.click();
	}
};

const openCloseWindow = function () {
	const container_text = document.getElementById('container_text_AI'),
		container_log = document.getElementById('container_log_AI');
	if (container_log.style.display === 'none') {
		container_text.style.width = '50%';
		container_log.style.display = 'block';
	} else {
		container_text.style.width = '100%';
		container_log.style.display = 'none';
	}
};

const createDivRealtime = function (transcriptions, buttonSendAudio, dc, fns, ms) {
	if (document.getElementById("realtimeCallContainer")) return;

	const containerInput = document.getElementById("container_input_AI");
	const callContainer = document.createElement("div");
	callContainer.id = "realtimeCallContainer";
	callContainer.className = 'realtime-call-container';

	document.querySelector('.container_display').style.height = 'calc(80% - 52px)';

	const callInfo = document.createElement("div");
	callInfo.innerHTML = `<strong>Ekrai</strong> <span id="callTimer">Connecting...</span>`;
	callInfo.style.cssText = "color: #626c42; font-size: 16px;";

	const audioIndicator = document.createElement("div");
	audioIndicator.style.cssText = `
		width: 50px; height: 50px; border-radius: 50%;
		background: radial-gradient(circle, #c0c69e 40%, transparent 50%);
		animation: pulse 1.5s infinite;
	`;

	const style = document.createElement("style");
	style.innerHTML = `
		@keyframes pulse {
			0% { transform: scale(1); opacity: 0.7; }
			50% { transform: scale(1.2); opacity: 1; }
			100% { transform: scale(1); opacity: 0.7; }
		}
	`;
	document.head.appendChild(style);

	const buttonsContainer = document.createElement("div");
	buttonsContainer.className = 'buttons-container';

	const muteButton = document.createElement("button");
	muteButton.className = "button mute-button";
	muteButton.innerHTML = `<span><svg fill="#31381d" width="22px" height="22px" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
								<path d="M12,15a4,4,0,0,0,4-4V5A4,4,0,0,0,8,5v6A4,4,0,0,0,12,15ZM10,5a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0Zm10,6a1,1,0,0,0-2,0A6,6,0,0,1,6,11a1,1,0,0,0-2,0,8,8,0,0,0,7,7.93V21H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13V18.93A8,8,0,0,0,20,11Z"/>
							</svg></span> <strong>Mute</strong>`;
	muteButton.onclick = () => {
		if (ms) {
			let audioTrack = ms.getAudioTracks()[0];

			if (audioTrack.enabled) {
				audioTrack.enabled = false;
				muteButton.innerHTML = `<span><svg fill="#31381d" width="22px" height="22px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path d="M10.5,3.73a2,2,0,0,1,2.95-.14A2,2,0,0,1,14,5V8.41a1,1,0,0,0,2,0V5A4,4,0,0,0,9,2.47,1,1,0,1,0,10.5,3.73Zm8.22,9.54.2,0a1,1,0,0,0,1-.81A7.91,7.91,0,0,0,20,11a1,1,0,0,0-2,0,5.54,5.54,0,0,1-.11,1.1A1,1,0,0,0,18.72,13.27Zm3,6.06-18-18a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41L8,8.48V11a4,4,0,0,0,6,3.46l1.46,1.46A6,6,0,0,1,6,11a1,1,0,0,0-2,0,8,8,0,0,0,7,7.93V21H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13V18.93a7.87,7.87,0,0,0,3.85-1.59l3.4,3.4a1,1,0,0,0,1.42-1.41ZM12,13a2,2,0,0,1-2-2v-.52l2.45,2.46A1.74,1.74,0,0,1,12,13Z"/>
					</svg></span> <strong>Unmute</strong>`;
			} else {
				audioTrack.enabled = true;
				muteButton.innerHTML = `<span><svg fill="#31381d" width="22px" height="22px" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg"><path d="M12,15a4,4,0,0,0,4-4V5A4,4,0,0,0,8,5v6A4,4,0,0,0,12,15ZM10,5a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0Zm10,6a1,1,0,0,0-2,0A6,6,0,0,1,6,11a1,1,0,0,0-2,0,8,8,0,0,0,7,7.93V21H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13V18.93A8,8,0,0,0,20,11Z"/></svg></span> <strong>Mute</strong>`;
			}
		}
	};

	const endCallButton = document.createElement("button");
	endCallButton.className = "button end-call-button";
	endCallButton.innerHTML = `<span><svg width="22px" height="22px" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" class="icon line-color">
    								<rect x="3" y="3" width="18" height="18" rx="1" style="fill: #FF0000; stroke: #FF0000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></rect>
								</svg></span> <strong>End call</strong>`;

	endCallButton.onclick = () => {
		$('#chatAudioButton').prop('disabled', false);
		if (transcriptions.length > 0) {
			$('#chatSendAudioButton').prop('disabled', false);
		}
		buttonSendAudio.prop('disabled', true);
		aborter.abort();
		aborter = new AbortController();
		enableAiForm(true);

		if (dc && dc.readyState === "open") {
			fns.closeConversation();
		}
		if (timerInterval) {
			clearInterval(timerInterval);
			timerInterval = null;
		}
		containerInput.classList.remove("hidden_container_input_AI");
		containerInput.classList.add("visible_container_input_AI");
		callContainer.remove();
		document.querySelector('.container_display').style.height = 'calc(100% - 52px)';
	};

	buttonsContainer.appendChild(muteButton);
	buttonsContainer.appendChild(endCallButton);

	callContainer.appendChild(callInfo);
	callContainer.appendChild(audioIndicator);
	callContainer.appendChild(buttonsContainer);

	containerInput.parentNode.insertBefore(callContainer, containerInput.nextSibling);
};


document.addEventListener('DOMContentLoaded', () => {
	const { site_url, nonceRealTimeApiSession, chat_log_value, transcribeSettingAudio, ai_query_params } = window.ekr_chat_ai_data;
	let transcribeSettingAudioBoolean = transcribeSettingAudio == 'true' ? true : false;
	const buttonAudio = $('#chatAudioButton'),
		buttonSendAudio = $('#chatSendAudioButton'),
		inputChatAI = $('#input_chat_AI'),
		button_chat = $('#button_input_AI'),
		button_log = $('#button_log_AI'),
		input = $('#input_chat_AI'),
		btn_abort = $('#btn_abort'),
		btn_import = $('#btn_import'),
		btn_change_session = $('#button_change_session'),
		baseUrl = "https://api.openai.com/v1/realtime/calls",
		model = "gpt-realtime-2025-08-28";

	let aborter = new AbortController(),
		transcriptions = [],
		tokenResponse;

	$('#chatSendAudioButton').prop('disabled', true);

	const fns = {
		closeConversation: () => {
			console.log('closeConversation chiamato!');
			console.trace();

			if (pc) {
				pc.close();
			}
			if (ms) {
				ms.getTracks().forEach(track => track.stop());
			}
			if (dc) {
				dc.close();
			}
			buttonAudio.prop('disabled', false);
			buttonAudio.removeClass("recording");
			inputChatAI.prop('disabled', false);
			button_chat.prop('disabled', false);
			if (transcriptions.length > 0) {
				buttonSendAudio.prop('disabled', false);
			}
			return { success: true };
		}
	};

	if (buttonAudio.length > 0) {
		buttonAudio.on('click', async function () {
			try {
				tokenResponse = await fetch(
					`${site_url}/wp-json/ekr/v1/get_openai_token_proxy?${ai_query_params}`,
					{
						method: 'GET',
						headers: {
							'X-Wp-Nonce': nonceRealTimeApiSession,
						},
					}
				);

				if (!tokenResponse.ok) {
					return;
				}

				const data = await tokenResponse.json(),
					EPHEMERAL_KEY = data.value;
				//console.log('STRUTTURA COMPLETA TOKEN:', JSON.stringify(data, null, 2));
				pc = new RTCPeerConnection();

				const audioEl = $('<audio autoplay></audio>');
				$('body').append(audioEl);

				pc.ontrack = (e) => {
					audioEl[0].srcObject = e.streams[0];
				};

				ms = await navigator.mediaDevices.getUserMedia({ audio: true });
				pc.addTrack(ms.getTracks()[0]);
				dc = pc.createDataChannel("oai-events");

				enableAiForm(false);
				buttonAudio.prop('disabled', true);
				buttonAudio.addClass("recording");
				inputChatAI.prop('disabled', true);
				button_chat.prop('disabled', true);
				buttonSendAudio.prop('disabled', true);

				const containerInput = document.getElementById("container_input_AI");
            	containerInput.classList.add("hidden_container_input_AI");
            	createDivRealtime(transcriptions, buttonSendAudio, dc, fns, ms);

				dc.addEventListener("open", () => {
					/*const updateEvent = {
						type: "session.update",
						session: {
							instructions: data.session.instructions,
							turn_detection: {
								type: "server_vad",
								threshold: 0.5,
								prefix_padding_ms: 200,
								silence_duration_ms: 600,
								create_response: true
							},
							input_audio_transcription: {
								model: "whisper-1"
							},
							tools: [{
								type: "function",
								name: "closeConversation",
								description: "Chiude la conversazione",
								parameters: {
									type: 'object',
									properties: {
										color: { type: 'string', description: 'alla frase \'chiudi conversazione\' viene chiamata la funzione' },
									},
								},
							}],
							tool_choice: "auto",
						}
					};*/
					const updateEvent = {
    type: "session.update",
    session: {
        type: "realtime",
        instructions: data.session.instructions,
        audio: {
            input: {
                turn_detection: {
                    type: "server_vad",
                    threshold: 0.5,
                    prefix_padding_ms: 200,
                    silence_duration_ms: 600,
                    create_response: true
                },
                transcription: {
                    model: "whisper-1"
                }
            }
        },
        tools: [{
            type: "function",
            name: "closeConversation",
            description: "Chiude la conversazione",
            parameters: {
                type: 'object',
                properties: {
                    color: { type: 'string', description: 'alla frase \'chiudi conversazione\' viene chiamata la funzione' },
                },
            },
        }],
        tool_choice: "auto",
    }
};
					dc.send(JSON.stringify(updateEvent));

					const callTimerElement = document.getElementById("callTimer");
					if (callTimerElement) {
						callTimerElement.textContent = "00:00";
						realtimeSeconds = 0;

						function updateTimer() {
							realtimeSeconds++;
							const minutes = String(Math.floor(realtimeSeconds / 60)).padStart(2, "0");
							const sec = String(realtimeSeconds % 60).padStart(2, "0");
							callTimerElement.textContent = `${minutes}:${sec}`;
						}

						timerInterval = setInterval(updateTimer, 1000);
					}
				});

				const scrollPositionAudio = $(window).scrollTop();

				dc.addEventListener("message", async (e) => {
					const dataRealTime = JSON.parse(e.data),
						container_text = $('#container_text_AI');
 					//console.log('🔵 EVENT:', dataRealTime.type, dataRealTime); // temporaneo
					switch (dataRealTime.type) {
						case "response.output_audio.done":
							setTimeout(() => {
								const answerContainer = createAnswerItem(true);
								appendItem(container_text, answerContainer);
								$(window).scrollTop(scrollPositionAudio);
							}, 400);
							break;

						case "conversation.item.input_audio_transcription.completed":
							if (dataRealTime.transcript !== "" && dataRealTime.transcript !== null) {
								const requestAudio = createRequestItem(dataRealTime.transcript);
								enableAiForm(false);
								appendItem(container_text, requestAudio);
								$(window).scrollTop(scrollPositionAudio);
								transcriptions.push({ client: dataRealTime.transcript });
								if (window.ekr_chat_ai_data.realtimetrigger !== '') {
									chatQuestionandAnswer.push('question: ' + dataRealTime.transcript);
								}
							}
							break;

						case "response.output_audio_transcript.done":
							if (transcribeSettingAudioBoolean) {
								setTimeout(() => {
									updateAnswerItem(marked.parse(dataRealTime.transcript));
									$(window).scrollTop(scrollPositionAudio);
									transcriptions.push({ server: dataRealTime.transcript });
									if (window.ekr_chat_ai_data.realtimetrigger !== '') {
										chatQuestionandAnswer.push('answer: ' + dataRealTime.transcript);
										checkPlaceholderAnswer(chatQuestionandAnswer[chatQuestionandAnswer.length - 1]);
									}
								}, 600);
							}
							break;

						case 'response.function_call_arguments.done':
							const fn = fns[dataRealTime.name];
							if (fn !== undefined) {
								let args;
								if (dataRealTime.arguments != 'undefined') {
									args = JSON.parse(dataRealTime.arguments);
								}
								const result = args !== undefined ? await fn(args) : await fn();

								if (dataRealTime.name !== 'closeConversation') {
									const event = {
										type: 'conversation.item.create',
										item: {
											type: 'function_call_output',
											call_id: dataRealTime.call_id,
											output: JSON.stringify(result),
										},
									};
									dc.send(JSON.stringify(event));
								} else {
									aborter.abort();
									aborter = new AbortController();
									enableAiForm(true);
								}
							}
							break;
					}
				});

				const offer = await pc.createOffer();
				await pc.setLocalDescription(offer);
				const sdpResponse = await fetch(`${baseUrl}?model=${model}`, {
					method: "POST",
					body: offer.sdp,
					headers: {
						Authorization: `Bearer ${EPHEMERAL_KEY}`,
						"Content-Type": "application/sdp"
					},
				});
				if (!sdpResponse.ok) {
					const errorText = await sdpResponse.text();
					console.error('Errore SDP response:', sdpResponse.status, errorText);
					throw new Error(`SDP exchange failed: ${errorText}`);
				}
				const answer = {
					type: "answer",
					sdp: await sdpResponse.text(),
				};
				await pc.setRemoteDescription(answer);
			} catch (error) {
				console.error('Errore connessione WebRTC:', error);
			}
		});
	}

	if (buttonSendAudio.length > 0) {
		buttonSendAudio.on('click', async () => {
			const container_text = $('#container_text_AI'),
				input = $('#input_chat_AI');
			if (transcriptions.length > 0) {
				const scrollPosition = $(window).scrollTop();
				const answerContainer = createAnswerItem(true);
				appendItem(container_text, answerContainer);
				$(window).scrollTop(scrollPosition);

				const TranscriptonParams = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Wp-Nonce': nonceRealTimeApiSession,
						'Authorization': `Basic ${btoa(proxyAiUsername + ':' + proxyAiPassword)}`
					},
					body: JSON.stringify({
						question: JSON.stringify(transcriptions),
						queryParams: ai_query_params,
						logEnabled: window.ekr_chat_ai_data.chat_log_value === '1',
						aiSessionId: aiSessionId,
						//se serve anche nella trascrizione, decommentare
						//sendFileToAiFromlabelBox: window.ekr_chat_ai_data.sendFileToAiFromlabelBox
					}),
				};
				readDataSSE(`${site_url}/wp-json/ekr/v1/sse_transcription`, TranscriptonParams);
				input.val('');
				window.ekr_ai_image = '';
			}
		});
	}

	if (button_chat) {
		button_chat.on('click', function () {
			sendRequest();
		});
	}

	if (inputChatAI) {
		inputChatAI.on('input', () => {
			//reset per ricalcolo
			inputChatAI.css('height', 'auto');
			const inputHeight = parseInt(getComputedStyle(inputChatAI[0]).height);
			//recupero altezza massima come un terzo dell'altezza totale della chat
			const chatContainer = $('#container_chat');
			const maxHeight = chatContainer.prop('clientHeight') * 0.33 - 12;
			//recupero l'altezza corretta, con Math.min utilizzo la scrollHeight della textarea oppure
			//la maxHeight se è più piccola
			const newHeight = Math.min(Math.max(inputChatAI.prop('scrollHeight'), inputHeight), maxHeight);
			//faccio crescere l'input
			inputChatAI.css('height', `${newHeight}px`);
			// mostra scrollbar solo se ha raggiunto il limite
			inputChatAI.css('overflow-y', inputChatAI.prop('scrollHeight') >= maxHeight ? 'auto' : 'hidden');
		});
	}

	if (chat_log_value === '1' && button_log) {
		button_log.on('click', function () {
			openCloseWindow();
		});
	}

	if (input) {
		input.on('keydown', function () {
			enter(input, button_chat);
		});
	}

	if (btn_abort) {
		btn_abort.on('click', function () {
			$('#chatAudioButton').prop('disabled', false);
			if (transcriptions.length > 0) {
				$('#chatSendAudioButton').prop('disabled', false);
			}
			buttonSendAudio.prop('disabled', true);
			aborter.abort();
			aborter = new AbortController();
			enableAiForm(true);

			if (dc && dc.readyState === "open") {
				fns.closeConversation();
			}
		});
	}

	if (btn_import) {
		btn_import.on('click', function () {
			importImage();
		});
	}

	if (btn_change_session) {
		btn_change_session.on('click', function () {
			aiSessionId = uuidv4();
			chatQuestionandAnswer = [];
		});
	}

	//se c'è il queryparam question, devo inoltrare la domanda
	const searchParams = new URL(window.location.href).searchParams;
	const questionParam = searchParams.get('question');
	if (questionParam) {
		sendRequest(questionParam);
	}
	console.log(window.ekr_chat_ai_data);
});
